<style lang="scss" scoped>
.query-form-div {
  padding: 12px;
}

.body-div {
  padding: 0 12px;
}

.pagination-div {
  padding: 12px;
  text-align: right;
}

.handle-div {
  padding: 12px;
  text-align: right;
}
</style>
<template>
  <div v-loading="allLoading" element-loading-text="数据加载中...">
    <div class="query-form-div">
      <el-form :inline="true" :model="qForm">
        <el-form-item label="裁判姓名">
          <el-input v-model="qForm.RefereeName" size="small" placeholder="裁判姓名" />
        </el-form-item>
        <el-form-item label="裁判岗位">
          <el-select v-model="qForm.RefereeTypeId" size="small" >
            <el-option label="全部" value="" />
            <el-option v-for="item in refereeTypes" :key="item.RefereeTypeId" :label="item.RefereeTypeName"
              :value="item.RefereeTypeId" />
          </el-select>
        </el-form-item>
        <el-form-item label="裁判手机号">
          <el-input v-model="qForm.RefereePhone" size="small" placeholder="裁判手机号" />
        </el-form-item>


        <el-form-item label="状态">
          <el-select v-model="qForm.IsLock" size="small">
            <el-option label="全部" value="" />
            <el-option label="正常" value="0" />
            <el-option label="锁定" value="1" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="allLoading" @click="query(true)"
            size="small">查询</el-button>
          <el-button icon="el-icon-plus" size="small" @click="insertReferee">添加裁判</el-button>
          <el-button  icon="el-icon-download" size="small" @click="showUploadDialog">导入</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="body-div">
      <el-table :data="tb.data" style="width: 100%" stripe border size="mini">
        <el-table-column label="裁判姓名" prop="RefereeName" align="center" width="300"/>
        <el-table-column label="裁判岗位" prop="RefereeTypeName" align="center" width="200" />
        <el-table-column label="手机号" prop="RefereePhone" align="center" width="150" />
        <el-table-column label="等级" prop="RefereeLevel" align="center" width="120" />
        <el-table-column label="描述" prop="RefereeDescribe" />
        <el-table-column label="状态" align="center" width="120">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.IsLock == 0 ? 'success' : 'error'" disable-transitions>{{ scope.row.IsLock == 1 ?
              "锁定" : "正常" }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" circle size="mini" @click.native.prevent="editReferee(scope.row)">
            </el-button>
            <el-button circle :type="scope.row.IsLock == 1 ? 'success' : 'warning'" size="mini"
            :icon="scope.row.IsLock == 0 ? 'el-icon-lock' : 'el-icon-unlock'"
              @click.native.prevent="lockOrUnLockReferee(scope.row)">
            </el-button>
            <el-button icon="el-icon-delete" circle type="danger" size="mini" @click.native.prevent="deleteReferee(scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="pagination-div">
      <el-pagination background :current-page="tb.pi" :page-sizes="[10, 20, 40, 60, 100]" :page-size="tb.ps"
        layout="total, sizes, prev, pager, next, jumper" :total="tb.total" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div> -->
    <el-dialog title="编辑裁判信息" :visible.sync="editDialogVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false" width="30%">
      <el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="80px">
        <el-form-item label="裁判姓名" prop="RefereeName">
          <el-input v-model="editForm.RefereeName" size="small" placeholder="裁判姓名" />
        </el-form-item>
        <el-form-item label="手机号" prop="RefereePhone">
          <el-input v-model="editForm.RefereePhone" size="small" placeholder="手机号" />
        </el-form-item>
        <el-form-item label="裁判岗位" prop="RefereeTypeId">
          <el-select v-model="editForm.RefereeTypeId" size="small">
            <el-option v-for="item in refereeTypes" :key="item.RefereeTypeId" :label="item.RefereeTypeName"
              :value="item.RefereeTypeId" />
          </el-select>
        </el-form-item>
        <el-form-item label="等级" prop="RefereeLevel">
          <el-select v-model="editForm.RefereeLevel" size="small">
            <el-option v-for="item in refereeLevel" :key="item" :label="item" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" v-model="editForm.RefereeDescribe" size="small" placeholder="描述" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submitEdit">确 定</el-button>
        <el-button type="info" size="small" @click="editDialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>


    <el-dialog title="导入" :visible.sync="uploadDialogVisible"  >
      <el-form  style="width: 80%; margin: 0 auto;" label-width="100px">
       
        <el-form-item label="上传文件">
          <el-upload class="upload-demo" ref="upload" drag :action="uploadUrl" 
          multiple :headers="requestHeaders" :auto-upload="false" 
          accept=".xlsx" :limit="1" :on-change="uploadRequestChange" :on-error="uploadError"
          :on-success="uploadSuccess" :file-list="uploadFileList">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将xlsx文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
          <p style="color: red;">注：如重复的裁判姓名，将会覆盖旧记录</p>
          <p style="color: red;">裁判岗位仅支持填写:<br>{{ refereeTypes.map(a=>a.RefereeTypeName).join(',') }}</p>
          <p style="color: red;">裁判等级仅支持填写:<br>{{ refereeLevel.join(',') }}</p>
          
          <label style="color: #409EFF;text-decoration: underline;" @click="downloadTemplate">下载导入模版</label>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sunmitUpload" size="small">确 定</el-button>
        <el-button type="info" @click="uploadDialogVisible = false" size="small">取 消</el-button>

      </span>
    </el-dialog>
  </div>
</template>
<script>
import MatchService from "@/request-server/request-services/match-services.js";
import systemServices from '../../../request-server/request-services/system-services';
import Url from '../../../request-server/request-url';
import Store from '../../../store';
import Router from '../../../router';

export default {
  data() {
    return {
      allLoading: false,
      editDialogVisible: false,
      uploadDialogVisible:false,
      uploadUrl:Url.getRequestBaseUrl() + 'MatchApi/ImportReferee',
      requestHeaders:{
        Authorization :'Bearer ' + Store.state.token
      },
      uploadFileList:[],
      qForm: {
        RefereeName: "",
        RefereePhone: "",
        IsLock: "",
        RefereeTypeId:''
      },
      refereeLevel: ['实习裁判', '三级', '二级', '一级', '国家级', '国际级'],
      editForm: {
        refereeId: "",
        RefereeName: "",
        RefereePhone: "",
        RefereeTypeId: '',
        RefereeLevel: "",
        RefereeDescribe: "",
      },
      refereeTypes: [],
      editFormRules: {
        RefereeName: [{ required: true, message: '裁判姓名不能为空', trigger: 'blur' }],
        RefereePhone: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
        RefereeLevel: [{ required: true, message: '等级不能为空', trigger: 'blur' }],
        RefereeTypeId: [{ required: true, message: '裁判岗位不能为空', trigger: 'blur' }],
      },
      tb: {
        pi: 1,
        ps: 10,
        total: 0,
        data: [],
      },

    };
  },
  created() {
    this.query();
    this.selectRefereeTypeList();
  },
  methods: {

    query(isInit) {
      if (isInit) {
        this.tb.pi = 1;
      }
      const qParams = {
        PageIndex: this.tb.pi,
        PageSize: this.tb.ps,
        Where: {
          RefereeName: this.qForm.RefereeName,
          RefereePhone: this.qForm.RefereePhone,
          IsLock: this.qForm.IsLock,
          RefereeTypeId:this.qForm.RefereeTypeId
        },
      };
      this.allLoading = true;
      MatchService.selectRefereeList(qParams).then((res) => {
        this.allLoading = false;
        if (res.code == 0) {
          this.tb.data = res.data.Data;
          this.tb.total = res.data.Total;
        }
      });
    },
    handleSizeChange(val) {
      this.tb.ps = val;
      this.query(true);
    },
    handleCurrentChange(val) {
      this.tb.pi = val;
      this.query(false);
    },
    insertReferee() {
      this.editForm = {
        refereeId: "",
        RefereeName: "",
        RefereePhone: "",
        RefereeLevel: "",
        RefereeDescribe: "",
      };
      this.editDialogVisible = true;
    },

    selectRefereeTypeList() {
      MatchService.selectRefereeTypeList().then(res => {
        if (res.code == 0) this.refereeTypes = res.data;
      })
    },

    editReferee(row) {
      this.editForm = row;
      this.editDialogVisible = true;
    },

    lockOrUnLockReferee(row) {
      this.$confirm(
        `确定要${row.IsLock == 0 ? "锁定" : "解锁"}该裁判吗？`,
        "提示"
      ).then(() => {
        this.allLoading = true;
        MatchService.lockOrUnLockReferee({ refereeId: row.RefereeId }).then((res) => {
          this.allLoading = false;
          if (res.code == 0) {
            this.$message.success(res.data);
            this.query(false);
          }
        });
      });
    },
    deleteReferee(row) {
      this.$confirm(`确定要删除该裁判吗？`, "提示").then(() => {
        this.allLoading = true;
        MatchService.delReferee({ refereeId: row.RefereeId }).then((res) => {
          this.allLoading = false;
          if (res.code == 0) {
            this.$message.success(res.data);
            this.query(false);
          }
        });
      });
    },
    submitEdit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.allLoading = true;
          MatchService.editReferee(this.editForm).then((res) => {
            this.allLoading = false;
            if (res.code == 0) {
              this.$message.success(res.data);
              this.query(false);
              this.editDialogVisible = false;
            }
          });
        }
      });
    },
    showUploadDialog(){
      this.uploadFileList = [];
      this.uploadDialogVisible = true;
    },
    uploadRequestChange(e){
      console.log(e);
    },
    uploadSuccess(response, file, fileList){
      if(response.isError){
        this.$message.error(response.msg);
      }else{
        //上传成功
        this.$message.success(response.data);
        this.uploadFileList = [];
        this.uploadDialogVisible = false;
        this.query(true)
      }
    },
    uploadError(response, file,fileList){
      console.log(response.status,response.data)
      if(response.status == 401){
        this.$message.error('登录失效，请重新登录');
        Router.replace({ path: '/login', query: { redirect: Router.currentRoute.path == "/login" ? "" : Router.currentRoute.path } });
      }else if(response.status == 500){
        this.$message.error('上传失败');
      }
    },
    sunmitUpload(){
      this.$refs.upload.submit();
    },
    downloadTemplate(){
      location.href = Url.getDownloadBaseUrl() + '/templatefiles/裁判信息模版.xlsx';
    }

  },
  computed: {

  },
};
</script>
